import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { TIRE_API_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

export class TireService {
  static getTireList = async (data = {}, offset = 0, limit = 20) => {
    try {
      const res = await HTTPHandler.post(TIRE_API_URL + '/tireSet/list', {
        ...data,
        offset,
        limit
      })
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getRimsBySetId = async setId => {
    try {
      const res = await HTTPHandler.get(
        TIRE_API_URL + '/tire/getBySetId/' + setId
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getMarks = async () => {
    try {
      const res = await HTTPHandler.get(TIRE_API_URL + '/markModel/getMarks')
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static uploadPhotos = async (files = []) => {
    try {
      const formData = new FormData()
      for (let i = 0; i < files.length; i++) {
        formData.append(`file`, files[i])
      }
      const res = await HTTPHandler.post(
        TIRE_API_URL + '/files/uploadFiles',
        formData,
        {
          'Content-Type': 'multipart/form-data'
        }
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }
}
